<script>
	import { Button, Label, WidgetCard } from '@Shelly/shelly-design-system';
	import WeatherLocationModal from 'src/components/Weather/WeatherLocationModal.svelte';
	import { user_data, user_settings } from 'src/stores/account/user';
	import { edit } from 'src/stores/ui/edit_lists';
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';
	import { push } from 'svelte-spa-router';
	let showWeatherLocationModal = false;
	export let weather;
	export let editMode = false;
	export let widgetCardRef;
	export let minHeight;

	const dispatch = createEventDispatcher();

	function dispatchEvent(eventName, detail = null) {
		dispatch(eventName, detail);
	}

	function handleWidgetClick() {
		dispatchEvent('childWidgetClick');
	}
</script>

{#if $user_data?.premium === 1}
	<!-- premium user without weather station -->
	{#if !$user_settings?.weather_station?.data?.stationName}
		<WidgetCard
			weather={{
				image: './images/weather/Cloudy.png',
			}}
			editMode={$edit}
			bind:widgetCardRef
			{minHeight}
		>
			<Label
				slot="leftBadge"
				size="s"
				icon="fas fa-gem"
				type="premium"
				value={$format('label_premium', { default: 'Premium' })}
				noRadiusType="second"
			/>
			<svelte:fragment slot="weatherContent">
				<Button on:click={() => (showWeatherLocationModal = true)} size="m" variant="premium"
					>{$format('button_add_weather_widget', {
						default: 'Add Weather Widget',
					})}</Button
				>
			</svelte:fragment>

			<svelte:fragment slot="bottom">
				<slot />
			</svelte:fragment>
		</WidgetCard>
		{#if showWeatherLocationModal}
			<WeatherLocationModal bind:showModal={showWeatherLocationModal} />
		{/if}
	{:else}
		<!-- premium user with weather station -->
		<WidgetCard bind:widgetCardRef {minHeight} {weather} {editMode} on:click={handleWidgetClick}>
			<svelte:fragment slot="bottom">
				<slot />
			</svelte:fragment></WidgetCard
		>
	{/if}
{:else if $user_settings.been_premium}
	<!-- basic user, but has been premium before-->
	<WidgetCard
		bind:widgetCardRef
		{minHeight}
		weather={{
			image: './images/weather/Cloudy.png',
		}}
		editMode={$edit}
		hideSlotBottom={!$edit}
	>
		<Label
			slot="leftBadge"
			size="s"
			icon="fas fa-gem"
			type="premium"
			value={$format('label_left_badge_weather_widget', {
				default: 'Weather Widget',
			})}
			noRadiusType="second"
		/>
		<svelte:fragment slot="weatherContent">
			<Button on:click={() => push('/settings/premium')} size="m" variant="premium"
				>{$format('button_become_premium', {
					default: 'Become Premium',
				})}</Button
			>
		</svelte:fragment>

		<svelte:fragment slot="bottom">
			<slot />
		</svelte:fragment>
	</WidgetCard>
{:else}
	<!-- basic user, but never been premium - don't render card -->
{/if}
